module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAANVJREFUOE9jZKAyYKSyeQyjBmKGqOGuBqn/f1i2MzL8337eq7aCUJjjDUOwYb+ZVzEwMH5jYPj/+j8jw/OLXrUl+AzFaSDMsP/M/9MZ/jKlMTD/m8X0jzHo339GgYveNcW4DMVqILJhFz3qrupvbZkIMhDENtzWXIvPUKwG6m9r2cPA9C8fZADIJcgGgvhgQxmZXl70rJ6F7lLsXv7fwMTA2PAPphjdQLA4mhqYWqISNlYDcQTiMDHQYEtT618O1rmXXSrvUZSwCWnGJk9UGJJi8Ag0EABSpm0VO3qF3gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_icon_arrow_litre.png
// module id = 1/ae
// module chunks = 0